import { ServicePage } from "../components/ServicePage";
import { BEFORE_AFTER } from "../data/content";

const faq = [
    {
        q: "Wann ist die beste Zeit für den Heckenschnitt?",
        a: "Schonende Form- und Pflegeschnitte sind das ganze Jahr über möglich – ideal sind Frühsommer und Spätsommer. Ein starker Rückschnitt bis ins alte Holz ist aus Vogelschutzgründen (§ 39 BNatSchG) nur zwischen dem 1. Oktober und dem 28. Februar erlaubt. Ich berate Sie, welcher Zeitpunkt für Ihre Hecke der richtige ist.",
    },
    {
        q: "Nehmen Sie das Schnittgut mit?",
        a: "Ja. Auf Wunsch nehme ich das komplette Schnittgut auf und entsorge es fachgerecht – Ihr Grundstück bleibt sauber zurück.",
    },
    {
        q: "Meine Hecke ist stark gewachsen. Lässt sich da noch etwas machen?",
        a: "In den meisten Fällen ja. Eibe, Liguster und Hainbuche vertragen einen kraftvollen Rückschnitt sehr gut. Thuja und andere Koniferen sollte man nicht bis ins braune Altholz schneiden – dort treiben sie nicht wieder aus. Ich schaue mir Ihre Hecke vorher an und sage Ihnen ehrlich, was möglich ist.",
    },
    {
        q: "Was kostet ein Heckenschnitt in Celle?",
        a: "Das hängt von Länge, Höhe und Zustand der Hecke ab. Nach einer kurzen kostenlosen Besichtigung – oder auf Basis Ihrer Fotos – erhalten Sie ein verbindliches Festpreis-Angebot, kostenlos und unverbindlich.",
    },
];

export const Heckenschnitt = () => (
    <ServicePage
        eyebrow="Leistung · Landkreis Celle"
        h1="Heckenschnitt in Celle – Formschnitt und Rückschnitt vom Profi"
        intro="Eine Hecke verzeiht keine schlampigen Schnitte – man sieht ihr jeden Fehler monatelang an. Ich schneide Ihre Hecke präzise in Form: vom feinen Pflegeschnitt bis zum kraftvollen Rückschnitt stark gewachsener Hecken. Im gesamten Landkreis Celle, zuverlässig und zum vereinbarten Festpreis."
        image="/leistung-heckenschnitt.webp"
        imageAlt="Heckenschnitt in Celle – Julian Kosinski beim Formschnitt mit der Heckenschere"
        scope={[
            "Formschnitt und regelmäßiger Pflegeschnitt",
            "Kraftvoller Rückschnitt stark gewachsener Hecken",
            "Hecken kürzen – in Höhe und Breite",
            "Thuja, Liguster, Kirschlorbeer und weitere Arten",
            "Schnittgut wird aufgenommen und entsorgt",
            "Einmalig oder als regelmäßige Heckenpflege",
        ]}
        sections={[
            {
                title: "Formschnitt und Pflegeschnitt",
                paragraphs: [
                    "Der regelmäßige Formschnitt hält Ihre Hecke dicht, gesund und in sauberer Form. Ich arbeite mit gespannten Linien und ruhiger Hand, damit Kanten gerade und Flächen eben werden – ohne Löcher und ohne Fransen.",
                    "Je nach Heckenart sind ein bis drei Schnitte pro Jahr sinnvoll. Gerne übernehme ich die Heckenpflege auch dauerhaft im festen Rhythmus, sodass Sie sich um nichts mehr kümmern müssen.",
                ],
            },
            {
                title: "Rückschnitt und Verjüngung",
                paragraphs: [
                    "Ist eine Hecke über Jahre zu hoch oder zu breit geworden, bringt nur ein deutlicher Rückschnitt sie wieder in ein gepflegtes Maß. Wie weit man zurückschneiden darf, hängt von der Heckenart ab – hier zahlt sich Erfahrung aus, denn ein zu tiefer Schnitt in unverträgliche Arten kann die Hecke dauerhaft schädigen.",
                    "Wichtig zu wissen: Starke Rückschnitte sind aus Vogelschutzgründen nur zwischen dem 1. Oktober und dem 28. Februar zulässig (§ 39 Bundesnaturschutzgesetz). Schonende Formschnitte sind dagegen ganzjährig möglich. Ich plane mit Ihnen den passenden Zeitpunkt.",
                ],
            },
            {
                title: "Typische Heckenarten im Raum Celle",
                paragraphs: [
                    "Thuja (Lebensbaum) braucht ein bis zwei Schnitte pro Jahr und darf nicht ins braune Altholz geschnitten werden. Liguster wächst kräftig und verträgt auch starke Schnitte sehr gut. Kirschlorbeer schneide ich schonend und einzeln, damit keine halbierten Blätter braun werden.",
                    "Eibe und Hainbuche sind besonders schnittverträglich und treiben selbst nach radikalem Rückschnitt wieder aus – ideal, wenn eine alte Hecke verjüngt werden soll. Welche Art bei Ihnen steht und was sie verträgt, klären wir kurz bei der Besichtigung.",
                ],
            },
        ]}
        pair={BEFORE_AFTER[1]}
        sliderTitle="Vorher / Nachher: Hecken-Formschnitt"
        faq={faq}
        serviceType="Heckenschnitt und Heckenpflege"
        related={[
            { to: "/rasenpflege-celle", label: "Rasenpflege in Celle" },
            { to: "/gartenpflege-celle", label: "Gartenpflege in Celle" },
            { to: "/referenzen", label: "Referenzen ansehen" },
        ]}
    />
);
